import { render, staticRenderFns } from "./HotelAccommodationCollapse.vue?vue&type=template&id=817990a0&scoped=true&"
import script from "./HotelAccommodationCollapse.vue?vue&type=script&lang=js&"
export * from "./HotelAccommodationCollapse.vue?vue&type=script&lang=js&"
import style0 from "./HotelAccommodationCollapse.vue?vue&type=style&index=0&id=817990a0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817990a0",
  null
  
)

export default component.exports